export default "__VITE_ASSET__BPjSnvsY__"